export const FETCH_ORDER_WITH_DETAILS_SUCCESS = 'FETCH_ORDER_WITH_DETAILS_SUCCESS';
export const FETCH_ORDER_WITH_DETAILS_REQUEST = 'FETCH_ORDER_WITH_DETAILS_REQUEST';
export const FETCH_ORDER_WITH_DETAILS_FAILURE = 'FETCH_ORDER_WITH_DETAILS_FAILURE';
export const FETCH_ORDER_WITH_DETAILS_REST = 'FETCH_ORDER_WITH_DETAILS_REST';
export const fetchOrderWithDetailsSuccess = (payload) => ({
    type: FETCH_ORDER_WITH_DETAILS_SUCCESS,
    payload,
});
export const fetchOrderWithDetailsRequest = (payload) => ({
    type: FETCH_ORDER_WITH_DETAILS_REQUEST,
    payload,
});
export const fetchOrderWithDetailsFailure = (payload) => ({
    type: FETCH_ORDER_WITH_DETAILS_FAILURE,
    payload,
});
export const fetchOrderWithDetailsReset = () => ({
    type: FETCH_ORDER_WITH_DETAILS_REST,
});
